window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

// Custom
$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})

$(function () {
  $('[data-toggle="popover"]').popover()
})

$(function () {
  $('.sidenav-button').click(function() {
    $('#sidenav-toggle').toggleClass('active')
  })
})

$(function () {
  $('#block-submit').submit(function() {
    $('#submit-btn', this)
      .html(`
        <span class="d-flex justify-content-center align-items-center">
          <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
          Chargement...
        </span>
      `)
      .attr('disabled', 'disabled')

    return true
  })
})

$(function () {
  $('#search').keyup(function (){
    $('#search2').remove()
  })

  $('#search2').keyup(function (){
    $('#search').remove()
  })
})

$(function () {
  $('#invoice-submit').on('click', function(e) {
    if ($('#invoice-submit').attr('disabled')) {
      e.preventDefault()

      return false
    }

    $('#invoice-submit')
    .html(`
      <span class="d-flex justify-content-center align-items-center">
        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        Génération en cours...
      </span>
    `)
    .attr('disabled', 'disabled')

    return true
  })
})
